import {call, put, takeEvery, all} from 'redux-saga/effects'

import {CREATE_KB_MESSAGES_REQUESTED, GET_KB_MESSAGES_REQUESTED} from '../actions/actionTypes'
import {messages} from '../../helpers/messages'
import {kbService} from "../../services/kb-exchange-service";
import {
  createMessageFailed,
  createMessageSuccess,
  getMessagesFailed,
  getMessagesSuccess
} from "../actions/kbExchangeActions";

const getDealNumber = async (data) =>
    await kbService.getDealNumber(data)
        .then((data) => data.data.deals )
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages["0"]
            if (errorData.errorCode) {
              commonError = messages[errorData.errorCode]
            }
            throw commonError
          }
        })

const getClientInfo = async (data) =>
    await kbService.getClientInfo(data)
        .then((data) => data.data.clients)
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages["0"]
            if (errorData.errorCode) {
              commonError = messages[errorData.errorCode]
            }
            throw commonError
          }
        })

const getMessages = async (data) =>
  await kbService
    .getMessages(data)
    .then(({data}) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })


function* fetchGetMessages ({payload}) {
  try {
    const messages = yield call(() => getMessages(payload))
    let updateMessages;
    if (messages.messages.length) {
      const dealIds = [...new Set(messages.messages.map(obj => obj.dealId))];
      const clientIds = [...new Set(messages.messages.map(obj => obj.clientId))];

      const [dealNumber, clients] = yield all([
        call(() => getDealNumber(dealIds)),
        call(() => getClientInfo(clientIds))
      ])
      const deal = {};
      const client = {};
      dealNumber.forEach(item => deal[item.id] = item);
      clients.forEach(item => client[item.id] = item);

      updateMessages = messages.messages.map(item => {
        return {
          ...item,
          dealNumber: item.dealId in deal ? deal[item.dealId].fields.dealNumber : '',
          client: item.clientId in client ? client[item.clientId] : null
        }
      })
    }  else {
      updateMessages = messages.messages
    }
    yield put(getMessagesSuccess({...messages, messages: updateMessages}))

  } catch (error) {
    yield put(getMessagesFailed(error))
  }
}

function* getMessagesSaga () {
  yield takeEvery(GET_KB_MESSAGES_REQUESTED, fetchGetMessages)
}

const createMessage = async (data) =>
  await kbService
    .createMessage(data)
    .then(({data}) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

function* fetchCreateMessage ({payload}) {
  try {
    const messages = yield call(() => createMessage(payload))
    yield put(createMessageSuccess(messages))
  } catch (error) {
    yield put(createMessageFailed(error))
  }
}

function* createMessageSaga () {
  yield takeEvery(CREATE_KB_MESSAGES_REQUESTED, fetchCreateMessage)
}


export {
  getMessagesSaga,
  createMessageSaga
}
